import { Currency } from 'api/v1/market'
import { findIndex } from 'lodash'
import { FC, useEffect, useMemo, useState, useRef } from 'react'
import { useDispatch } from 'react-redux'
import {
  updateBaseToken,
  updateCurrentConvertInfo,
  updateQuoteToken,
} from 'store/convert/actions'
import {
  useConvertBaseToken,
  useConvertQuoteToken,
  useConvertTokenConfig,
} from 'store/convert/hooks'
import { useCurrencies } from 'store/market/hooks'
import Iconfont from '../Iconfont'
import { useActionState } from 'store/app/hooks'
import {
  parseEtherToWei,
  parseWeiToEther,
  toFixed,
  toGrouping,
} from 'utils/number'
import Loading from 'components/Loading'
import { SelectedCoin, FormHeader } from './style'
import {
  SelectWrap,
  SelectSelector,
  OptionItem,
  SelectSelectorInfo,
  SelectorInfoRight,
  TokenLise,
  SelectOptionsWrap,
  FilterInput,
  SearchInput,
  SearchIcon,
} from './pupup.styles'
import { Fade, Stack } from '@mui/material'
import { useOnClickOutside } from 'usehooks-ts'
import { useCurrencyBalance } from 'store/account/hooks'
import { ReactComponent as SvgSelected } from './assets/selected.svg'

const SHOW_MIN_SEARCH_LIMI = 10

export const TokenFrom: FC<{ typeName: string }> = ({ typeName }) => {
  const baseToken = useConvertBaseToken()
  const quoteToken = useConvertQuoteToken()
  const convertTokenConfig = useConvertTokenConfig()
  const [isIn, setIsIn] = useState(false)
  const modalRef = useRef<any>()
  const [inputSearch, setInputSearch] = useState<string>('')
  const symbolsScale = {} as any

  const isBaseTokenForm = typeName === 'From'
  const { token: selectedToken } = isBaseTokenForm ? baseToken : quoteToken

  const { token: hideToken } = isBaseTokenForm ? quoteToken : baseToken
  const dispatch = useDispatch()
  const tokenList = useCurrencies()
  const balancesPulling = useActionState('ethereumBalancesPulling')
  const l2Balance = useCurrencyBalance(selectedToken?.name!)?.available ?? '0'

  useOnClickOutside(modalRef, () => setIsIn(false))

  useEffect(() => {
    if (!selectedToken) return
    const targetSymbol = convertTokenConfig.find(
      (item) => item.id === selectedToken.id,
    )
    const { minTradeVolume, maxTradeVolume } = targetSymbol || {
      minTradeVolume: '',
      maxTradeVolume: '',
    }
    let minSize = minTradeVolume + ''
    let maxSize = maxTradeVolume + ''
    if (isBaseTokenForm) {
      dispatch(updateCurrentConvertInfo({ baseRange: { minSize, maxSize } }))
    } else {
      dispatch(updateCurrentConvertInfo({ quoteRange: { minSize, maxSize } }))
    }
  }, [selectedToken, convertTokenConfig])

  const allTokenList = useMemo(() => {
    let newtokenListes: any[] = tokenList

    newtokenListes = newtokenListes.filter(
      (item) =>
        findIndex(convertTokenConfig, function (o) {
          return o.id == item.id
        }) > -1,
    )

    newtokenListes = newtokenListes.filter((item) => item?.id !== hideToken?.id)
    return newtokenListes
  }, [tokenList, hideToken, convertTokenConfig])

  useEffect(() => {
    if (allTokenList?.length > 0 && !selectedToken) {
      let default_token: Currency | null = null
      if (typeName === 'From') {
        default_token = allTokenList.filter((d) => d.name === 'WETH')[0]
      } else {
        default_token = allTokenList.filter((d) => d.name === 'USDC')[0]
      }
      default_token && onTokenSelected(default_token)
    }
  }, [typeName, allTokenList, selectedToken])

  const filterOptions = useMemo(() => {
    let newOptionList = allTokenList

    newOptionList = newOptionList.filter((item) => {
      const up = item['name'] ? (item['name'] as string).toUpperCase() : ''
      return up.indexOf(inputSearch.toUpperCase()) > -1
    })
    return newOptionList
  }, [allTokenList, inputSearch])

  const onTokenSelected = (token: Currency) => {
    dispatch(
      updateCurrentConvertInfo({
        price: '',
        priceFrom: '',
        priceTo: '',
        quoteAmount: '',
        baseAmount: '',
      }),
    )
    if (isBaseTokenForm) {
      dispatch(updateBaseToken({ token, amount: '' }))
    } else {
      dispatch(updateQuoteToken({ token }))
    }
  }

  return (
    <>
      <FormHeader>
        <span>{typeName}</span>
        <Stack
          direction={'row'}
          style={{ fontSize: '12px', color: 'rgba(175, 191, 202, 1)' }}
        >
          Balance:
          {selectedToken?.name
            ? toGrouping(
                parseWeiToEther(l2Balance, symbolsScale[selectedToken?.name]),
                6,
              )
            : '0.00'}{' '}
          {selectedToken?.name}
          {balancesPulling ? (
            <>
              <Loading size={12} />
            </>
          ) : null}
        </Stack>
      </FormHeader>
      {/* <FromLabel>{typeName}</FromLabel>
      <Stack
        direction={'row'}
        style={{ fontSize: '12px', color: 'rgba(175, 191, 202, 1)' }}
      >
        Balance:
        {selectedToken?.name
          ? toGrouping(
              parseWeiToEther(l2Balance, symbolsScale[selectedToken?.name]),
              6,
            )
          : '0.00'}{' '}
        {selectedToken?.name}
        {balancesPulling ? (
          <>
            <Loading size={12} />
          </>
        ) : null}
      </Stack> */}

      <SelectWrap ref={modalRef}>
        <SelectSelector
          onClick={() => setIsIn(!isIn)}
          className={isIn ? 'in' : ''}
        >
          <SelectSelectorInfo>
            <SelectedCoin>
              <img
                src={selectedToken?.tokenIconUrl}
                alt=""
                className="icon-img"
              />
              <span>{selectedToken?.name}</span>
            </SelectedCoin>
          </SelectSelectorInfo>
          <SelectorInfoRight>
            <Iconfont name="icon-ArrowDown" size={20} className="arrow" />
          </SelectorInfoRight>
        </SelectSelector>
        <Fade in={isIn} timeout={200}>
          <SelectOptionsWrap in={isIn ? 1 : 2}>
            <FilterInput>
              <SearchIcon>
                <Iconfont name="icon-Search" size={18} />
              </SearchIcon>
              <SearchInput
                type={'text'}
                placeholder="Search"
                onChange={(e) => {
                  setInputSearch(e.currentTarget.value)
                }}
              />
            </FilterInput>
            <TokenLise>
              {filterOptions.map((item) => {
                return (
                  <OptionItem
                    key={item.id}
                    className={item.id === selectedToken?.id ? 'active' : ''}
                    onClick={() => {
                      onTokenSelected(item)
                      isIn && setIsIn(false)
                    }}
                  >
                    <div className="left">
                      <img src={item.tokenIconUrl} alt="" />
                      <span>{item.name}</span>
                    </div>
                    {selectedToken?.name === item.name && (
                      <div className="right">
                        <SvgSelected />
                      </div>
                    )}
                  </OptionItem>
                )
              })}
            </TokenLise>
          </SelectOptionsWrap>
        </Fade>
      </SelectWrap>
    </>
  )
}
